<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="门店信息" left-arrow right-text="修改门店信息" @click-left="onClickLeft"
      @click-right="onClickRight">
      <!--通过插槽自定义导航栏右侧的内容 start-->
      <!-- <template #right>
        <van-icon name="wap-home-o" size="20" @click="onClickRight" />
      </template> -->
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
    <!--导航栏 end-->
    <!--内容 start-->

    <div style="margin-top: 1.2rem">
      <!-- <van-dropdown-menu>
                <van-dropdown-item  ref="item" :title="store_name">
                     <div v-for="(bububu,index) in option1" :key="index">
                            <van-cell @click="outlet(bububu.id,bububu.store_name)" :title="bububu.store_name" is-link/>
                     </div>
                </van-dropdown-item>
        </van-dropdown-menu> -->
      <van-cell-group>
        <van-cell title="门店编号" :value="list.store_num" />
        <van-cell title="门店名称" :value="list.store_name" />
        <van-cell title="门店联系人" :value="list.store_contact" />
        <van-cell title="联系人电话" :value="list.store_tel" />
        <van-cell title="门店信息" :value="list.store_info" />
        <van-cell title="地址" :value="this.value" />
        <van-cell title="店铺分类" :value="this.value2" />
        <van-cell title="门店图片">
          <template #right-icon>
            <van-image width="50" height="50" :src="Config.baseURL + list.store_img" />
          </template>
        </van-cell>
        <van-cell title="D0结算费率" :value="list.d0_rate" />
        <!-- <van-cell title="D1结算费率" :value="list.d1_rate" /> -->
        <van-cell title="入驻时间" :value="list.create_time" />
        <van-cell title="是否营业" :value="['暂停营业', '开业'][list.store_is_start]" />
        <van-cell title="是否开通外卖" :value="['否', '是'][list.is_delivery]" />
        <van-cell v-if="list.is_delivery == 1" title="配送费" :value="list.delivery_money" />
        <van-cell title="店铺经营类型" :value="list.shop_type == '01' ? '直营' : '加盟'" />
        <van-cell v-if="list.dinner_type" title="餐饮类型" :value="this.value3" />
        <van-cell title="门店地址">
          <template #label>
            <div class="label">
              <span> {{ list.store_address }}</span>
              <div class="button" @click="changeAddress">修改</div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <!--内容 end-->
    <changeMap v-if="is_map" style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;z-index: 999;"
      @getLocation="getLoacation"></changeMap>
  </div>
</template>

<script>
import Config from "../../../config";
import area from "@/utils/area.js";
import type from "@/utils/type.js";
import changeMap from "@/components/map.vue";

export default {
  name: "StoresStoreInformation", //门店信息
  components: {
    changeMap,
  },
  data() {
    return {
      list: [],
      area: [],
      type: [],
      value: "",
      value2: "",
      alipay_city_code: "",
      alipay_district_code: "",
      alipay_province_code: "",
      alipay_shop_category: "",
      is_map: false,
      value3: '',
      dinner_typeList: [
        {
          "code": "A01",
          "text": "正餐-本帮江浙菜",
        },
        {
          "code": "A02",
          "text": "正餐-日本菜",
        },
        {
          "code": "A03",
          "text": "正餐-西餐",
        },
        {
          "code": "A04",
          "text": "正餐-粤菜",
        },
        {
          "code": "A05",
          "text": "正餐-韩国料理",
        },
        {
          "code": "A06",
          "text": "正餐-川菜",
        },
        {
          "code": "A07",
          "text": "正餐-东南亚菜",
        },
        {
          "code": "A08",
          "text": "正餐-江河湖海鲜",
        },
        {
          "code": "A09",
          "text": "正餐-东北菜",
        },
        {
          "code": "A10",
          "text": "正餐-新疆菜",
        },
        {
          "code": "A11",
          "text": "正餐-素食",
        },
        {
          "code": "A12",
          "text": "正餐-湘菜",
        },
        {
          "code": "A13",
          "text": "正餐-早茶",
        },
        {
          "code": "A14",
          "text": "正餐-北京菜",
        },
        {
          "code": "A15",
          "text": "正餐-农家菜",
        },
        {
          "code": "A16",
          "text": "正餐-家常菜",
        },
        {
          "code": "A17",
          "text": "正餐-特色菜",
        },
        {
          "code": "A18",
          "text": "正餐-私房菜",
        },
        {
          "code": "A19",
          "text": "正餐-创意菜",
        },
        {
          "code": "A20",
          "text": "正餐-中东菜",
        },
        {
          "code": "B01",
          "text": "快餐-小吃快餐",
        },
        {
          "code": "B02",
          "text": "快餐-小龙虾",
        },
        {
          "code": "B03",
          "text": "快餐-烧烤烤串",
        },
        {
          "code": "B04",
          "text": "快餐-面馆",
        },
        {
          "code": "B05",
          "text": "快餐-烤肉",
        },
        {
          "code": "C01",
          "text": "火锅-火锅",
        },
        {
          "code": "D01",
          "text": "面包甜点-面包甜点",
        },
        {
          "code": "E01",
          "text": "茶饮咖啡-咖啡厅",
        },
        {
          "code": "E02",
          "text": "茶饮咖啡-饮品店",
        },
        {
          "code": "F01",
          "text": "零食卤味-水果生鲜",
        },
        {
          "code": "F02",
          "text": "零食卤味-食品保健",
        },
        {
          "code": "F03",
          "text": "零食卤味-卤味熟食",
        },
        {
          "code": "F04",
          "text": "零食卤味-零食干果",
        },
        {
          "code": "G01",
          "text": "酒餐-酒店自助餐",
        },
      ]
    };
  },
  mounted() {
    this.choose();
    this.area = area.area;
    this.type = type.type;
  },
  methods: {
    getSelectAlipayShopCategory(code, arr) {
      let index = 0;
      let p_index = 0;
      let text = "";
      let p_text = "";
      for (let i = 0; i < arr.length; i++) {
        let children = arr[i].children;
        for (let j = 0; j < children.length; j++) {
          if (children[j].code == code) {
            p_index = i;
            index = j;
            p_text = arr[i].text;
            text = children[j].text;
          }
        }
      }
      return { p_index, index, p_text, text };
    },
    getLoacation(res) {
      this.is_map = false;
      this.list.store_address = res.poiaddress;
      var reqData = {
        store_lng: res.latlng.lng,
        store_lat: res.latlng.lat,
        store_address: res.poiaddress,
      };
      this.$http
        .post("/wechat/api.store.index/editStore", reqData)
        .then((res1) => {
          var res = res1.body;
          this.$toast.success(res.msg);
        })
        .catch((err) => {
          this.$toast.fail("操作失败");
        });
    },
    changeAddress() {
      this.is_map = true;
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/StoresInformation");
    },
    // 右侧跳转修改门店
    onClickRight() {
      // 跳转修改门店
      this.$router.push("/StoresStoreInformationUpdate");
    },

    //门店选择
    // outlet(a,b){
    //    this.store_id=a;
    //    this.store_name=b;
    //    console.log(a,b);
    //    this.$refs.item.toggle();
    //    this.choose()
    // },
    //全部门店列表
    //    theStores(){
    //              this.$http.get('/wechat/user/get_merchant_list', {
    //             params: {
    //                 merchant_id:window.sessionStorage.getItem("commercialId"),
    //             }
    //         }).then(response => {
    //             console.log(response.data.data);
    //             this.option1=response.data.data
    //             // this.number()
    //             // this.choose()
    //         })
    //    },
    //默认会选择第一家门店
    // number(){
    //     if (this.store_id=="") {
    //         this.store_id=this.option1[0].id
    //         this.store_name=this.option1[0].store_name
    //       }
    // },
    //选择每个门店
    choose() {
      this.$http
        .get("/wechat/api.merchant_info/get_store_info", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
            store_id: window.sessionStorage.getItem("store_id"),
          },
        })
        .then((response) => {
          console.log(response.data.data);
          this.list = response.data.data;
          this.alipay_city_code = this.list.alipay_city_code;
          this.alipay_district_code = this.list.alipay_district_code;
          this.alipay_province_code = this.list.alipay_province_code;
          this.alipay_shop_category = this.list.alipay_shop_category;
          this.dinner_type = response.body.data.dinner_type
          this.dinner_typeList.map(i => {
            if (this.dinner_type == i.code) {
              this.value3 = i.text
            }
          })
          let index_arr = [];
          let text_arr = [];
          let sheng_code = this.alipay_province_code;
          let shi_code = this.alipay_city_code;
          let qu_code = this.alipay_district_code;
          for (let i0 = 0; i0 < this.area.length; i0++) {
            if (this.area[i0].code == sheng_code) {
              index_arr[0] = i0;
              text_arr[0] = this.area[i0].text;
              let shi_arr = this.area[i0].children;
              for (let i1 = 0; i1 < shi_arr.length; i1++) {
                if (shi_arr[i1].code == shi_code) {
                  index_arr[1] = i1;
                  text_arr[1] = shi_arr[i1].text;
                  let qu_arr = shi_arr[i1].children;
                  for (let i2 = 0; i2 < qu_arr.length; i2++) {
                    if (qu_arr[i2].code == qu_code) {
                      index_arr[2] = i2;
                      text_arr[2] = qu_arr[i2].text;
                    }
                  }
                }
              }
            }
          }
          this.value = text_arr;
          let select = this.getSelectAlipayShopCategory(
            this.alipay_shop_category,
            this.type
          );
          console.log("ddddddddddd", select);
          this.value2 = select.p_text + "," + select.text;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.label {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .button {
    width: 40px;
    height: 20px;
    background-color: #1989fa;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
    font-size: 10px;
    color: #fff;
  }
}
</style>
